<template>
<el-row :gutter="20">
  <el-col :span="24" :offset="0">
    <div class="grid-content bg-purple">
    <h1>{{msg}}</h1>
    <h1>{{form.name}}</h1>
    <el-table :data="awardsSubList" border style="width: 100%">
        <el-table-column type="index" width="80">
        </el-table-column>
        <el-table-column prop="subname" label="子榜单分类">
          <template scope="scope">
                  <router-link :to="{name: 'thissub', params: {subid: scope.row.id}}">{{scope.row.subname}}</router-link>
                </template>
        </el-table-column>
    </el-table>
    </div>
  </el-col>


</el-row>
</template>
<script>
export default {
  name: 'sublist',
  data () {
   return {
      msg: '',
      data: [],
      form: {},
      awardsSubList: [],
    }
  },

  mounted: function(){
        this.$nextTick(function () {
            this.$http.get('/api/awards/getawardsdetail',{params : {id: this.$route.params.id}}).then(
                response => {
                  console.log(response.body);
                  this.form = response.body.award;
                  if((response.body.list != undefined) && (response.body.list.length > 0)){
                    this.awardsSubList = response.body.list;
                  }
                },
                response => {
                  console.log('failed');
                }
              );
          });

    },
  methods: {
              
          }

}



</script>



// WEBPACK FOOTER //
// src/components/Sublist.vue